import { fetcher } from '@commenda/utils';
import { BASE_URL } from './helpers';
import { IFormsTemplate, UpdateFormsTemplateDto } from './types';

interface UpdateFormsTemplateResponse {
  success: boolean;
  data?: {
    formsTemplate: IFormsTemplate;
  };
}

/**
 * Update an existing form template
 */
export async function updateFormsTemplate(
  templateId: string,
  data: UpdateFormsTemplateDto
): Promise<UpdateFormsTemplateResponse> {
  try {
    const res = await fetcher(`${BASE_URL}/${templateId}`, {
      method: 'POST',
      body: data,
    });

    if (!res.ok) {
      console.error('Failed to update form template:', await res.text());
      return { success: false };
    }

    const responseData = await res.json();
    return { success: true, data: responseData };
  } catch (err) {
    console.error('Error updating form template:', err);
    return { success: false };
  }
}
